/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgNoteIcon: FC<IProps> = ({ width = 20, height = 20, color = "#6B6B6B" }) => (
  <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.4987 1.66669H4.9987C4.55667 1.66669 4.13275 1.84228 3.82019 2.15484C3.50763 2.4674 3.33203 2.89133 3.33203 3.33335V16.6667C3.33203 17.1087 3.50763 17.5326 3.82019 17.8452C4.13275 18.1578 4.55667 18.3334 4.9987 18.3334H14.9987C15.4407 18.3334 15.8646 18.1578 16.1772 17.8452C16.4898 17.5326 16.6654 17.1087 16.6654 16.6667V5.83335L12.4987 1.66669Z"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.668 1.66669V5.00002C11.668 5.44205 11.8436 5.86597 12.1561 6.17853C12.4687 6.49109 12.8926 6.66669 13.3346 6.66669H16.668"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8.33464 7.5H6.66797" stroke={color} strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M13.3346 10.8333H6.66797"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.3346 14.1667H6.66797"
      stroke={color}
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgNoteIcon;
